import React, { Fragment, useState, useCallback } from 'react';

// Material UI
import { Grid, Menu, Icon } from '@mui/material';
import NavigationIcon from '@mui/icons-material/Navigation';
import Skeleton from '@mui/material/Skeleton';

// Components
import { Loading, Tooltip } from 'Components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

// Styles
import './styles.scss';

const VehicleStatusIconPicker = (props) => {
  const { icon, icons, disabled, loading, showDefaulIcon } = props;
  //State
  const [anchorEl, setAnchorEl] = useState(null);

  const onChange = useCallback((value) => {
    if (!value) return;
    if (props.onChange) props.onChange(value);
  });

  const renderPicker = () => {
    return (
      <Fragment>
        {
          icon
            ? renderIcon()
            : <NavigationIcon className={`box-icon ${disabled ? 'disabled' : ''}`} />
        }
      </Fragment>
    );
  }

  const renderIcon = () => {
    return (
      <Fragment>
        {
            <Fragment>
              {
                loading ?
                  <Skeleton
                    variant="rectangular"
                    className={`box-icon`}
                    style={{
                      borderRadius: 4
                    }}
                  /> :
                  <LazyLoadImage
                    className={`box-icon ${disabled ? 'disabled' : ''}`}
                    src={`/assets/icons/${icon}`}
                    alt={'icon'}
                    effect="blur"
                    delayTime={500}
                    beforeLoad={() => {
                      // setLoadingIcon(true);
                    }}
                    afterLoad={() => {
                      // setLoadingIcon(false)
                    }}
                    style={{
                      borderRadius: 4
                    }}
                  />
              }
            </Fragment>
        }
      </Fragment>
    );
  }

  const DefaultIcon = () => {
    return (
      <Grid item={true} xs key={0}>
        <Tooltip title={''} placement={'bottom'}>
          <Icon
            className={`icon-image ${icon == null ? 'active' : ''}`}
            onClick={() => onChange({ icon: null, id: 0 })} >
            {'navigation'}
          </Icon>
        </Tooltip>
      </Grid>

    )
  }

  const renderIcons = useCallback((icons) => {

    if (!icons || !icons.length) {
      return <Grid item xs />;
    }

    return (
      <Fragment>
        {
          showDefaulIcon && <DefaultIcon />
        }
        {
          icons.map((item, key) => {

            if(!item?.icon) return null

            let selected = item.id === props.vehicleStatusId;

            return (
              <Grid item={true} xs key={key}>
                <Tooltip title={item.name || ''} placement={'bottom'}>
                  <div style={{width:'20px'}}>
                    <LazyLoadImage
                      className={`icon-image ${selected ? 'active' : ''}`}
                      alt={item.name}
                      effect="blur"
                      src={`/assets/icons/${item.icon}`}
                      delayTime={500}
                      onClick={() => onChange(item)}
                    />
                  </div>
                </Tooltip>
              </Grid>
            )
          })
        }
      </Fragment>
    )
  });

  return (
    <div style={{width: '25px'}}>
      <div onClick={(event) => !disabled && setAnchorEl(event.currentTarget)}>
        {renderPicker()}
      </div>
      <Menu
        id="vehicule-status-icon-picker"
        anchorEl={anchorEl}
        open={anchorEl ? true : false}
        onClose={() => setAnchorEl(null)}
      >
        <div className="icons-container">
          <Fragment>
            {
              loading ?
                <Loading full /> :
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >
                  {renderIcons(icons)}
                </Grid>
            }
          </Fragment>
        </div>
      </Menu>
    </div>
  );
}

export default VehicleStatusIconPicker;